import axios from 'axios';
import config from '../config';

axios.defaults.withCredentials = true;

export const getFavouriteOrganisations = () => {
    return axios.get(`${config.baseURL}/organisations/favorites`);
};

export const addFavouriteOrganisation = (uuid) => {
    return axios.post(`${config.baseURL}/organisations/${uuid}/favorite`);
};

export const removeFavouriteOrganisation = (uuid) => {
    return axios.delete(`${config.baseURL}/organisations/${uuid}/favorite`);
};
